<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{
              "pages.packageSales.form.fields.packageInformations" | translate
            }}
          </legend>

          <div class="row">
            <!-- title -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.title"
                [control]="form?.get('title')"
                label="common.title"
              >
              </form-field>
            </div>
            <!-- depositPrice -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [hasCurrency]="true"
                [(value)]="model.depositPrice"
                [control]="form?.get('depositPrice')"
                label="common.depositPrice"
                type="tel"
                [hasNumberSeparator]="true"
              >
              </form-field>
            </div>

            <!-- originalPrice -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.originalPrice"
                [control]="form?.get('originalPrice')"
                [hasCurrency]="true"
                type="tel"
                [hasNumberSeparator]="true"
                label="common.originalPrice"
              >
              </form-field>
            </div>

            <!-- expirationType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                enumName="ExpirationType"
                [label]="fields + 'expirationType'"
                [control]="form?.get('expirationType')"
                [(value)]="model.expirationType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- expiration -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.expiration"
                [control]="form?.get('expiration')"
                [label]="fields + 'expiration' | translate"
              >
              </form-field>
            </div>

            <!-- isActive -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4 tw-flex tw-justify-start tw-items-center">
              <mat-slide-toggle
                formControlName="isActive"
                [(ngModel)]="model.isActive"
              >
                {{ "common.active" | translate }}</mat-slide-toggle
              >
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
